module.exports = __webpack_public_path__ + "static/media/445608342_1965078913894563_7955116937410324553_n.d92ef5ef.jpg";